import { database } from '@/firebase';

const {
  getCollection,
  setRecord,
  deleteRecord,
} = database;

export default {
  createSeason({ dispatch }, season) {
    const { id, ...value } = season;
    return setRecord({
      model: 'seasons',
      id,
      value,
    }).then(() => dispatch('fetch', { model: 'seasons' }));
  },
  fetchAllSeasons({ commit, dispatch }) {
    return dispatch('fetch', { model: 'strips' })
      .then(() => getCollection({ model: 'seasons' }))
      .then((response) => {
        commit('set', { model: 'seasons', value: response });
      });
  },
  removeSeason({ dispatch }, id) {
    return deleteRecord({
      model: 'seasons',
      id,
    }).then(() => dispatch('fetch', { model: 'seasons' }));
  },
};
